module.exports = __webpack_public_path__ + "static/movantik-naloxegol-55ecf16f7a4543483600bde5d2d1aa8e.png";